var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{staticClass:"logo",attrs:{"alt":"logo","src":require("../assets/images/logoL.svg")}})
}
var staticRenderFns = []

export { render, staticRenderFns }